import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import styles from 'components/features/future/FutureField/PremiumInput.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import LockSvg from 'icons/lock-filled.svg'
import { useFormContext } from 'react-hook-form'

type PremiumInputProps = {
  name: string
  value: string
}
export const PremiumInput: FC<PremiumInputProps> = (props) => {
  const { children, name, value } = props
  const { register } = useFormContext()

  const dispatch = useStoreDispatch()
  const handleOpenSubscription = useCallback(() => {
    dispatch(openSubscriptionPageActionCreator())
  }, [dispatch])

  return (
    <div className={ styles.premiumInput } onClick={ handleOpenSubscription }>
      <input
        type='text'
        readOnly
        className={ styles.hidden }
        { ...register(name) }
        defaultValue={ value }
      />
      <div className={ styles.inner }>
        { children }
        <div className={ styles.icon }>
          <SvgIcon src={ LockSvg } />
        </div>
      </div>
    </div>
  )
}
